module.exports = __webpack_public_path__ + "img/矩形(7).224f635f.png";